import React from 'react'

import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import Flex from 'styled-flex-component'

import InfluencerIdentityRowDetailsLocationAgeGender from '@components/InfluencerIdentity/Row/Details/LocationAgeGender'
import { Hr } from '@components/UI/Hr/Hr.styled'
import { IModalComponentProps } from '@context/Modal'
import { AudienceInsightsSource } from '@enums'
import { IApplicationState } from '@store'
import {
  fetchAudienceInsights,
  selectAudienceInsights,
  selectAudienceInsightsIsFetching,
} from '@store/audienceInsights'
import {
  selectIdentityAge,
  selectIdentityAudienceInsightsLink,
  selectIdentityFormattedLocationAndGender,
} from '@store/brandFans'
import Theme from '@theme'
import { CloseIcon, Container, H3, Modal } from '@tribegroup'
import BrandFanInfluencerIdentityRow from '../InfluencerIdentity/Row'
import BrandFansAudienceInsightsMerics from './Metrics'

interface IProps extends IModalComponentProps {
  identityId: number
  brandFanMemberId?: number
  brandFanGroupId?: number
}

const BrandFansAudienceInsights: React.FC<IProps> = ({
  identityId,
  onRequestClose,
  isOpen = false,
  brandFanMemberId,
  brandFanGroupId,
}) => {
  const dispatch = useDispatch()
  const isFetching = useSelector((state: IApplicationState) =>
    selectAudienceInsightsIsFetching(state),
  )
  const audienceInsights = useSelector((state: IApplicationState) =>
    selectAudienceInsights(state, identityId),
  )
  const age = useSelector((state: IApplicationState) => selectIdentityAge(state, identityId))
  const locationAndGender = useSelector((state: IApplicationState) =>
    selectIdentityFormattedLocationAndGender(state, identityId),
  )
  const hasAudienceInsightsLink = useSelector((state: IApplicationState) =>
    Boolean(selectIdentityAudienceInsightsLink(state, identityId)),
  )

  React.useEffect(() => {
    if (hasAudienceInsightsLink) {
      dispatch(fetchAudienceInsights(identityId, AudienceInsightsSource.Identity))
    }
  }, [hasAudienceInsightsLink, identityId])
  return (
    <Modal reactModalProps={{ isOpen }} width={53.25} complex>
      <Container data-testid="audience-insights-modal">
        <CloseIcon onClick={onRequestClose} />
        <div>
          <BrandFanInfluencerIdentityRow
            horizontalPadding={0}
            identityId={identityId}
            showCTAs={false}
            showLocationGenderAgeSection={false}
            showSubmissions={false}
            brandFanGroupId={brandFanGroupId}
            brandFanMemberId={brandFanMemberId}
          />
        </div>
        <InfluencerIdentityRowDetailsLocationAgeGender
          showMidDot={false}
          locationAndGender={locationAndGender}
          age={age}
        />

        {hasAudienceInsightsLink && (
          <>
            <Container topOuterSpacing={1.875} maxHeight="55vh" overflow="auto">
              <Flex alignCenter justifyStart>
                <H3 color={Theme.grey900Color}>
                  <FormattedMessage id="core.text.audienceMetrics" />
                </H3>
              </Flex>
              <Container topOuterSpacing={0.625}>
                <Hr />
              </Container>
              <BrandFansAudienceInsightsMerics
                isFetching={isFetching}
                audienceInsights={audienceInsights}
              />
            </Container>
          </>
        )}
        <Hr />
      </Container>
    </Modal>
  )
}

export default BrandFansAudienceInsights
